import React from 'react';
  const categories = [
    { 
      id: 'Red Dot', 
      name: 'Red Dot', 
      svg: (
        <svg viewBox="0 0 100 100" className="w-24 h-24">
          <circle cx="50" cy="50" r="35" stroke="#ef4444" strokeWidth="2" fill="none" />
          <circle cx="50" cy="50" r="4" fill="#ef4444" />
        </svg>
      ),
      description: 'Close-range precision' 
    },
    { 
      id: 'Holographic', 
      name: 'Holographic',
      svg: (
        <svg viewBox="0 0 100 100" className="w-24 h-24">
          <rect x="20" y="35" width="60" height="30" stroke="#f59e0b" strokeWidth="2" fill="none" rx="3" />
          <circle cx="50" cy="50" r="15" stroke="#f59e0b" strokeWidth="1.5" fill="none" />
          <circle cx="50" cy="50" r="2" fill="#f59e0b" />
          <line x1="50" y1="35" x2="50" y2="40" stroke="#f59e0b" strokeWidth="1.5" />
          <line x1="50" y1="60" x2="50" y2="65" stroke="#f59e0b" strokeWidth="1.5" />
          <line x1="35" y1="50" x2="40" y2="50" stroke="#f59e0b" strokeWidth="1.5" />
          <line x1="60" y1="50" x2="65" y2="50" stroke="#f59e0b" strokeWidth="1.5" />
        </svg>
      ),
      description: 'Holographic sights' 
    },
    { 
      id: 'Rifle Scope', 
      name: 'Rifle Scope',
      svg: (
        <svg viewBox="0 0 140 100" className="w-28 h-20">
          <rect x="15" y="44" width="110" height="12" stroke="#60a5fa" strokeWidth="2" fill="none" />
          <ellipse cx="15" cy="50" rx="6" ry="10" stroke="#60a5fa" strokeWidth="2" fill="none" />
          <ellipse cx="125" cy="50" rx="4" ry="7" stroke="#60a5fa" strokeWidth="2" fill="none" />
          <ellipse cx="125" cy="50" rx="5" ry="8" stroke="#60a5fa" strokeWidth="1" fill="none" opacity="0.5" />
          <rect x="60" y="42" width="20" height="16" stroke="#60a5fa" strokeWidth="2" fill="none" rx="2" />
          <circle cx="70" cy="35" r="5" stroke="#60a5fa" strokeWidth="1.5" fill="none" />
          <circle cx="70" cy="35" r="3" stroke="#60a5fa" strokeWidth="1" fill="none" />
          <circle cx="85" cy="50" r="5" stroke="#60a5fa" strokeWidth="1.5" fill="none" />
          <circle cx="85" cy="50" r="3" stroke="#60a5fa" strokeWidth="1" fill="none" />
        </svg>
      ),
      description: 'Long-range accuracy' 
    },
    { 
      id: 'LPVO', 
      name: 'LPVO',
      svg: (
        <svg viewBox="0 0 100 100" className="w-24 h-24">
          <rect x="25" y="44" width="50" height="12" stroke="#a78bfa" strokeWidth="2" fill="none" />
          <ellipse cx="25" cy="50" rx="4" ry="8" stroke="#a78bfa" strokeWidth="2" fill="none" />
          <path d="M 75 44 Q 82 44 85 42 L 85 58 Q 82 56 75 56" stroke="#a78bfa" strokeWidth="2" fill="none" />
          <ellipse cx="85" cy="50" rx="4" ry="8" stroke="#a78bfa" strokeWidth="2" fill="none" />
          <rect x="67" y="42" width="8" height="16" stroke="#a78bfa" strokeWidth="2" fill="none" />
          <rect x="70" y="38" width="8" height="6" stroke="#a78bfa" strokeWidth="1.5" fill="none" rx="1" />
          <rect x="42" y="42" width="16" height="16" stroke="#a78bfa" strokeWidth="2" fill="none" rx="2" />
          <circle cx="50" cy="34" r="4" stroke="#a78bfa" strokeWidth="1.5" fill="none" />
          <circle cx="50" cy="34" r="2.5" stroke="#a78bfa" strokeWidth="1" fill="none" />
          <circle cx="60" cy="50" r="4" stroke="#a78bfa" strokeWidth="1.5" fill="none" />
          <circle cx="60" cy="50" r="2.5" stroke="#a78bfa" strokeWidth="1" fill="none" />
        </svg>
      ),
      description: 'Versatile 1-6x optics' 
    },
    { 
      id: 'Prism Scope', 
      name: 'Prism Scope',
      svg: (
        <svg viewBox="0 0 100 100" className="w-24 h-24">
          <polygon points="30,60 50,30 70,60" stroke="#ec4899" strokeWidth="2" fill="none" />
          <circle cx="50" cy="50" r="20" stroke="#ec4899" strokeWidth="1.5" fill="none" />
          <circle cx="50" cy="50" r="3" fill="#ec4899" />
          <line x1="40" y1="50" x2="45" y2="50" stroke="#ec4899" strokeWidth="1.5" />
          <line x1="55" y1="50" x2="60" y2="50" stroke="#ec4899" strokeWidth="1.5" />
        </svg>
      ),
      description: 'Compact prism optics' 
    },
    { 
      id: 'Magnifier', 
      name: 'Magnifier',
      svg: (
        <svg viewBox="0 0 100 100" className="w-24 h-24">
          <rect x="25" y="35" width="50" height="30" stroke="#10b981" strokeWidth="2" fill="none" rx="3" />
          <circle cx="35" cy="50" r="8" stroke="#10b981" strokeWidth="2" fill="none" />
          <circle cx="65" cy="50" r="8" stroke="#10b981" strokeWidth="2" fill="none" />
          <line x1="42" y1="50" x2="58" y2="50" stroke="#10b981" strokeWidth="2" />
          <rect x="45" y="45" width="10" height="10" stroke="#10b981" strokeWidth="1.5" fill="none" />
          <path d="M 25 40 L 20 35 M 25 60 L 20 65" stroke="#10b981" strokeWidth="2" />
          <path d="M 75 40 L 80 35 M 75 60 L 80 65" stroke="#10b981" strokeWidth="2" />
        </svg>
       ),
       description: 'Extend Your Range'
      }
  ];

export default categories;
